import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="about" className="py-24 lg:py-32 bg-[#F7F3EC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div
          ref={ref}
          className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Left — Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden w-full h-[460px] lg:h-[560px]">
              <img
                src="https://readdy.ai/api/search-image?query=sustainable%20timber%20processing%20mill%20facility%20in%20Chilean%20Patagonia%20surrounded%20by%20managed%20forest%2C%20organized%20lumber%20yard%20with%20premium%20wood%20products%20stacked%20neatly%2C%20warm%20natural%20afternoon%20sunlight%2C%20panoramic%20view%20showing%20harmony%20between%20industrial%20operation%20and%20pristine%20native%20forest%2C%20professional%20photography%2C%20warm%20earthy%20tones&width=800&height=900&seq=about-mill-01&orientation=portrait"
                alt="Sustainable Forest Mill Operation"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-4 lg:-right-8 bg-[#2D5E3F] text-white rounded-2xl p-5 w-36 text-center">
              <div className="text-3xl font-bold font-playfair">20+</div>
              <div className="text-xs text-white/80 mt-1 leading-tight">Years of Industry<br/>Excellence</div>
            </div>
            {/* Decorative element */}
            <div className="absolute -top-4 -left-4 w-24 h-24 rounded-xl bg-[#C68B3C]/20 -z-10"></div>
          </div>

          {/* Right — Text */}
          <div className="lg:pl-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#2D5E3F]/10 rounded-full mb-6">
              <span className="w-2 h-2 rounded-full bg-[#2D5E3F] inline-block"></span>
              <span className="text-[#2D5E3F] text-xs font-semibold tracking-widest uppercase">Who We Are</span>
            </div>

            <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-[#1C1C1C] font-semibold leading-tight mb-6">
              Bridging The <br />World&apos;s Forests<br />
              <em className="font-playfair italic font-normal text-[#2D5E3F]">With the U.S. Market</em>
            </h2>

            <p className="text-stone-600 text-base leading-relaxed mb-5">
              At VBMex LLC, we are a leading forest products brokerage with <strong>sustainability at our core</strong>, 
              dedicated to bringing premium timber and engineered wood products from South America and 
              across the world to buyers in the United States.
            </p>

            <p className="text-stone-600 text-base leading-relaxed mb-8">
              With deep roots in the South American timber industry and strong relationships with top 
              producers across Chile, Brazil, and Argentina, we offer unmatched access to quality 
              forest products — from MDF panels and plywood to OSB, KD lumber, and treated wood solutions.
            </p>

            {/* Feature list */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
              {[
                { icon: 'ri-leaf-line', label: 'Sustainability Focused' },
                { icon: 'ri-global-line', label: 'Global Supplier Network' },
                { icon: 'ri-shield-check-line', label: 'Quality Guaranteed' },
                { icon: 'ri-truck-line', label: 'Efficient Logistics' },
              ].map((feat) => (
                <div key={feat.label} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-[#2D5E3F]/10">
                    <i className={`${feat.icon} text-[#2D5E3F] text-base`}></i>
                  </div>
                  <span className="text-stone-700 text-sm font-medium">{feat.label}</span>
                </div>
              ))}
            </div>

            <button
              onClick={() => document.querySelector('#mission-vision')?.scrollIntoView({ behavior: 'smooth' })}
              className="inline-flex items-center gap-2 px-6 py-3 border border-[#2D5E3F] text-[#2D5E3F] text-sm font-medium rounded-full hover:bg-[#2D5E3F] hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Our Mission &amp; Vision
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
